module.exports = __webpack_public_path__ + "static/media/c4_2.58732c56.png";